<form [formGroup]="form">
  <input
    type="text"
    pInputText
    maxlength="50"
    spellcheck="false"
    formControlName="name"
    (input)="onTextFieldInput($event)"
    (blur)="onTextFieldBlur($event)"
  />
</form>
